import { IntegrationsPage } from '@/components/features/integrations/IntegrationsPage'
import { useClient } from '@/context/ClientContext'
import { useOrganisationUsersWithUserMap } from '@/hooks/useOrganisationUsersWithUserMap'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/orgs/$orgId_/projects/$projectId/integrations',
)({
  component: ProjectIntegrations,
  loader: async ({ context }) => {
    return { crumb: 'Integrations', metadata: context.metadata }
  },
})

function ProjectIntegrations() {
  const { orgId, projectId } = Route.useParams()
  const { metadata } = Route.useRouteContext()
  const { organisationClient, userClient } = useClient()

  const { userMap } = useOrganisationUsersWithUserMap({
    orgId,
    organisationClient,
    userClient,
    metadata,
  })

  return (
    <IntegrationsPage
      projectId={projectId}
      metadata={metadata}
      userMap={userMap}
    />
  )
}
